import { render } from "./InstanceCounter.vue?vue&type=template&id=a64310ea&scoped=true"
import script from "./InstanceCounter.vue?vue&type=script&lang=js"
export * from "./InstanceCounter.vue?vue&type=script&lang=js"

import "./InstanceCounter.vue?vue&type=style&index=0&id=a64310ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a64310ea"]])

export default __exports__